module.exports = __webpack_public_path__ + "favicon-16x16.cdb0d0d8.png";